<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>{{ restaurant.title || 'Ресторан' }}: Стол заказов</strong>
                    <RestaurantTableOrderBadge :show="savedForTableOrders" />
                </CCardHeader>
                <CCardBody>
                    <RestaurantsTabLinks />

                    <CRow class="pl-3 pb-3" />
                    <CRow>
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label"
                        >
                            Для стола заказов
                        </CCol>
                        <CCol sm="9">
                            <CSwitch
                                color="dark"
                                shape="pill"
                                variant="opposite"
                                :checked="!!restaurant.show_in_table_orders"
                                @update:checked="restaurant.show_in_table_orders = $event"
                            />
                        </CCol>
                    </CRow>

                    <CRow class="pl-3 pb-3" />
                    <CRow>
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label"
                        >
                            Приём заказа за, часов
                        </CCol>
                        <CCol sm="3">
                            <input
                                v-model="leadHoursDraft"
                                type="number"
                                min="1"
                                max="336"
                                class="form-control"
                                placeholder="по слотам"
                            >
                        </CCol>
                    </CRow>
                    <p class="text-muted pl-3">
                        Пусто — действуют сроки слотов стола доставки
                        (10:00–10:15 до 09:00, 12:30–12:45 до 11:00, 15:30–15:45 до 14:00).
                        Для ресторана кейтеринга укажите 24: заказ принимают за сутки до начала слота.
                        Блюда категории «Кейтеринг» и так закрываются за 24 часа.
                    </p>

                    <CRow class="pl-3 pb-3" />
                    <CRow class="pl-3 pb-3">
                        <strong>Соответствие категорий iiko</strong>
                    </CRow>
                    <p class="text-muted pl-3">
                        При интеграции название категории iiko сопоставляется
                        с категорией стола заказов. Соответствие можно поправить вручную.
                    </p>
                    <CButton
                        color="secondary"
                        class="ml-3 mb-3"
                        :disabled="remapping"
                        @click="remap"
                    >
                        Проставить по имени
                    </CButton>
                    <table v-if="restaurantCategories.length" class="table">
                        <thead>
                            <tr>
                                <th>Категория iiko</th>
                                <th>Категория стола заказов</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="row in restaurantCategories"
                                :key="row.id"
                            >
                                <td>{{ row.title }}</td>
                                <td>
                                    <select
                                        class="form-control"
                                        :value="row.shop_category_id || ''"
                                        @change="setMapping(row, $event.target.value)"
                                    >
                                        <option value="">Не сопоставлено</option>
                                        <option
                                            v-for="category in categories"
                                            :key="category.id"
                                            :value="category.id"
                                        >
                                            {{ category.title }}
                                        </option>
                                    </select>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p v-else-if="categoriesLoaded" class="text-muted pl-3">
                        У ресторана нет категорий iiko.
                    </p>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        :disabled="saving || !restaurant.id"
                        @click="save"
                    >
                        Сохранить
                    </CButton>
                    <CButton
                        color="light"
                        class="mr-3"
                        :disabled="saving"
                        @click="cancel"
                    >
                        Отмена
                    </CButton>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
import Vue from 'vue';
import RestaurantsTabLinks from '@/components/RestaurantsTabLinks';

export default {
    name: 'RestaurantShopCatalog',

    components: {
        RestaurantsTabLinks
    },

    data() {
        return {
            restaurant: {
                title: '',
                show_in_table_orders: false
            },
            savedForTableOrders: null,
            leadHoursDraft: '',
            savedLeadHours: null,
            savedMappings: {},
            categories: [],
            restaurantCategories: [],
            categoriesLoaded: false,
            remapping: false,
            saving: false
        };
    },

    mounted() {
        this.loadRestaurant();
        this.loadCategories();
        this.loadRestaurantCategories();
    },

    methods: {
        mappingValue(value) {
            if (value === null || value === undefined || value === '') return null;
            const id = Number(value);
            return Number.isFinite(id) && id > 0 ? id : null;
        },

        rememberMappings(rows) {
            const saved = {};
            rows.forEach(row => {
                saved[row.id] = this.mappingValue(row.shop_category_id);
            });
            this.savedMappings = saved;
        },

        loadRestaurant() {
            Vue.axios.get('/restaurants/' + this.$route.params.id)
                .then(({ data }) => {
                    this.restaurant = data;
                    this.savedForTableOrders = !!data.show_in_table_orders;
                    this.savedLeadHours = data.shop_order_lead_hours || null;
                    this.leadHoursDraft = data.shop_order_lead_hours
                        ? String(data.shop_order_lead_hours)
                        : '';
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Не удалось загрузить ресторан');
                });
        },

        loadCategories() {
            Vue.axios.get('/shop-catalog')
                .then(({ data }) => {
                    this.categories = data.categories || [];
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Не удалось загрузить категории стола заказов');
                });
        },

        loadRestaurantCategories() {
            Vue.axios.get(`/shop-catalog/restaurants/${this.$route.params.id}/categories`)
                .then(({ data }) => {
                    this.restaurantCategories = data;
                    this.rememberMappings(data);
                    this.categoriesLoaded = true;
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Не удалось загрузить категории ресторана');
                });
        },

        setMapping(row, value) {
            row.shop_category_id = this.mappingValue(value);
        },

        remap() {
            this.remapping = true;
            Vue.axios.post('/shop-catalog/remap', {
                restaurant_id: Number(this.$route.params.id),
                preview: true
            })
                .then(({ data }) => {
                    const byId = {};
                    (data.proposals || []).forEach(item => {
                        byId[item.id] = item.shop_category_id;
                    });
                    this.restaurantCategories.forEach(row => {
                        if (Object.prototype.hasOwnProperty.call(byId, row.id)) {
                            row.shop_category_id = byId[row.id];
                        }
                    });
                })
                .catch(err => {
                    this.$root.$emit('showError', err.response?.data?.error || 'Не удалось сопоставить категории');
                })
                .finally(() => {
                    this.remapping = false;
                });
        },

        cancel() {
            this.$router.push('/restaurants/' + this.$route.params.id);
        },

        save() {
            if (this.saving || !this.restaurant.id) return;
            this.saving = true;

            const tasks = [];
            const leadHours = this.leadHoursDraft === '' || this.leadHoursDraft == null
                ? null
                : Number(this.leadHoursDraft);
            const normalizedLead = Number.isFinite(leadHours) && leadHours > 0 ? leadHours : null;
            const flagChanged = !!this.restaurant.show_in_table_orders !== !!this.savedForTableOrders;
            const leadChanged = normalizedLead !== this.savedLeadHours;
            if (flagChanged || leadChanged) {
                const payload = {
                    ...this.restaurant,
                    shop_order_lead_hours: normalizedLead
                };
                delete payload.why_is_it_off;
                tasks.push(
                    Vue.axios.post('/restaurants/update/' + this.restaurant.id, payload)
                        .then(({ data }) => {
                            this.restaurant = data;
                            this.savedForTableOrders = !!data.show_in_table_orders;
                            this.savedLeadHours = data.shop_order_lead_hours || null;
                            this.leadHoursDraft = data.shop_order_lead_hours
                                ? String(data.shop_order_lead_hours)
                                : '';
                        })
                );
            }

            this.restaurantCategories.forEach(row => {
                const next = this.mappingValue(row.shop_category_id);
                const previous = this.mappingValue(this.savedMappings[row.id]);
                if (next === previous) return;
                tasks.push(
                    Vue.axios.put(`/shop-catalog/restaurant-categories/${row.id}`, {
                        shop_category_id: next
                    }).then(() => {
                        this.$set(this.savedMappings, row.id, next);
                    })
                );
            });

            if (!tasks.length) {
                this.saving = false;
                this.$root.$emit('showSuccess', 'Сохранено');
                return;
            }

            Promise.all(tasks)
                .then(() => {
                    this.$root.$emit('showSuccess', 'Сохранено');
                })
                .catch(err => {
                    this.$root.$emit('showError', err.response?.data?.error || 'Не удалось сохранить');
                })
                .finally(() => {
                    this.saving = false;
                });
        }
    }
};
</script>
